// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"ExchangeModal_modalContainer__2o6a1","header":"ExchangeModal_header__XyetE","title":"ExchangeModal_title__3TJm1","rule":"ExchangeModal_rule__3zwh6"};